export default __webpack_public_path__ + "static/prosody1.1_Babygirl-271a7ecfd0f9f8042a438356fbc482bb.wav";